import React, { useEffect, useState } from "react";
import { ButtonWrapper, ButtonText } from "./styles";
import { SelectButtonProps } from "./types";
import { Checkbox } from "../Checkbox";
// import Icon from "../../Icon";
// import CheckBox from "../CheckBox";

export const SelectButton: React.FC<SelectButtonProps> = ({
  label,
  isChecked = false,
  onClick,
  onChange,
  size,
  backgroundColor = "#00688D",
  uncheckedBackgroundColor = "#FFFFFF",
  checkedIconColor = "#00688D",
  uncheckedIconColor = "#FFFFFF",
  withCheckBox,
  // iconName,
}) => {
  const [isSelected, handlerSelected] = useState(isChecked);
  useEffect(() => {
    handlerSelected(isChecked);
  }, [isChecked]);

  return (
    <ButtonWrapper
      onClick={() => {
        onClick?.();
        onChange?.(!isSelected);
      }}
      backgroundColor={isSelected ? backgroundColor : uncheckedBackgroundColor}
      size={size}
    >
      {withCheckBox && (
        <Checkbox
          name="airports"
          isChecked={isSelected}
          color="black"
          onChange={(value) => {
            // handlerSelected(!isSelected);
          }}
        />
      )}
      {/* {iconName && (
        <Icon
          iconName={iconName}
          width={22}
          iconColor={isChecked ? uncheckedIconColor : checkedIconColor}
        />
      )} */}
      {label && (
        <ButtonText
          isChecked={isSelected}
          color={isSelected ? uncheckedIconColor : checkedIconColor}
        >
          {label}
        </ButtonText>
      )}
    </ButtonWrapper>
  );
};

export default SelectButton;
